/**
 * You can register global components here and use them as a plugin in your main Vue instance

 * Ideally, only small components that are re-used many times across your application should be registered here.

 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
*/

import PasswordField from '@/components/UIComponents/Inputs/PasswordField.vue';
import Button from '@/components/UIComponents/Button.vue';
import MessageHTML from '@/components/UIComponents/MessageHTML.vue';
import CardContainer from '@/components/UIComponents/CardContainer.vue';
import TableView from '@/components/UIComponents/TableView.vue';
import ReadMore from '@/components/UIComponents/ReadMore.vue';
import NumberInput from '@/components/UIComponents/NumberInput.vue';
import PhoneNumberInput from '@/components/UIComponents/PhoneNumberInput.vue';
import DialogForm from '@/components/UIComponents/DialogForm.vue';
import AddressAutocompleteInput from '@/components/UIComponents/AddressAutocompleteInput.vue';
import GoGoGoogleMap from '@/components/UIComponents/GoGoGoogleMap.vue';
import OrderingAddress from '@/components/UIComponents/OrderingForms/OrderingAddress.vue';
import CustomLocationButtons from '@/components/UIComponents/CustomLocationButtons.vue';
import AddressSection from '@/components/UIComponents/CardAddressSection.vue';
import ExpandAddressSection from '@/components/UIComponents/ExpandAddressSection.vue';
import StripeElements from '@/components/UIComponents/StripeElements.vue';
import FullCalendar from '@/components/UIComponents/FullCalendar.vue';
import DropdownList from '@/components/UIComponents/DropdownList.vue';
import DatePicker from '@/components/UIComponents/DatePicker.vue';
import TimePicker from '@/components/UIComponents/TimePicker.vue';
import Pagination from '@/components/UIComponents/Pagination.vue';
import PasswordFieldsContainer from '@/components/UIComponents/PasswordFieldsContainer.vue';
import FamilyPageWrapper from '@/components/UIComponents/FamilyPageWrapper.vue';
import CustomizedForm from '@/components/UIComponents/CustomizedForm.vue';
import EditableCard from '@/containers/EditableCard.vue';
import EmailInput from '@/components/UIComponents/Inputs/EmailInput.vue';
import WeatherViewer from '@/components/UIComponents/WeatherViewer.vue';
import SanitizedInput from '@/components/UIComponents/Inputs/SanitizedInput.vue';
import SanitizedTextarea from '@/components/UIComponents/Inputs/SanitizedTextarea.vue';
import AudioPlayer from '@/components/UIComponents/AudioPlayer.vue';
import AddPaymentMethodWrapper from '@/components/UIComponents/Payments/AddPaymentMethodWrapper.vue';
import PageFormsList from '@/components/UIComponents/PageFormsList.vue';

const registerGlobalElements = (app: any) => {
  app.component('PasswordField', PasswordField);
  app.component('PButton', Button);
  app.component('MessageHtml', MessageHTML);
  app.component('CardContainer', CardContainer);
  app.component('TableViewContainer', TableView);
  app.component('ReadMore', ReadMore);
  app.component('NumberInput', NumberInput);
  app.component('PhoneNumberInput', PhoneNumberInput);
  app.component('DialogForm', DialogForm);
  app.component('AddressAutocompleteInput', AddressAutocompleteInput);
  app.component('GoGoGoogleMap', GoGoGoogleMap);
  app.component('OrderingAddress', OrderingAddress);
  app.component('CustomLocationButtons', CustomLocationButtons);
  app.component('StripeElements', StripeElements);
  app.component('AddressSection', AddressSection);
  app.component('ExpandAddressSection', ExpandAddressSection);
  app.component('FullCalendar', FullCalendar);
  app.component('DropdownList', DropdownList);
  app.component('DatePicker', DatePicker);
  app.component('TimePicker', TimePicker);
  app.component('Pagination', Pagination);
  app.component('PasswordFieldsContainer', PasswordFieldsContainer);
  app.component('FamilyPageWrapper', FamilyPageWrapper);
  app.component('CustomizedForm', CustomizedForm);
  app.component('EditableCard', EditableCard);
  app.component('EmailInput', EmailInput);
  app.component('WeatherViewer', WeatherViewer);
  app.component('SanitizedInput', SanitizedInput);
  app.component('SanitizedTextarea', SanitizedTextarea);
  app.component('AudioPlayer', AudioPlayer);
  app.component('AddPaymentMethodWrapper', AddPaymentMethodWrapper);
  app.component('PageFormsList', PageFormsList);
};

export default registerGlobalElements;
